import React from 'react'
import Header from '../components/Header'
import { Footer } from '../components/SharedLayout'
import { HudsonPricingSlider } from '../components/ui/pricing-slider-loops'

const PricingSliderDemo: React.FC = () => {
  const heading = 'rgb(15,15,15)'
  const sub = 'rgb(76,76,75)'
  const accentColor = '#9B775D'

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24 sm:pt-28 pb-16">
        <div className="flex flex-col gap-8 items-center justify-center text-center py-16">
          <div className="flex flex-col gap-2 items-center justify-center text-center">
            <p className="font-bold text-base tracking-[0.4px]" style={{ color: accentColor }}>Pricing</p>
            <h1 className="text-4xl font-bold" style={{ color: heading }}>One price, all the things</h1>
            <p className="tracking-[0.4px] leading-[1.4em] text-center max-w-md mt-2" style={{ color: sub }}>
              Experience effortless homeownership with our comprehensive, proactive maintenance plans tailored to your property size.
            </p>
          </div>

          <HudsonPricingSlider />
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default PricingSliderDemo
